import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  TextField,
  Switch,
  styled,
  Typography,
  MenuItem,
  Grid,
} from "@mui/material";
import styles from "./TaskCreation.module.css";
import React, { useState, useEffect, useRef } from "react";
import TaskTypeSelect from "../../pages/app/Nurture/components/TaskTypeSelect/TaskTypeSelect";
import UserAssign from "../UserAssign/UserAssign";
import FlagAssign from "../FlagAssign/FlagAssign";
import { useAuthUser } from "react-auth-kit";
import { Mention, MentionsInput } from "react-mentions";
import { useSelector } from "react-redux";
import { getCombinedAssignees, formatTaskCategory } from "../CommonFunctions/CommonFunctions";
import Recurrence from "../../components/Recurrence/Recurrence";
import moment from "moment";
import "moment-timezone";
import { DesktopDatePicker, DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function TaskCreation(props: any) {
  const {
    CreateTask,
    employees,
    leadById,
    handleCancelClick,
    taskTypes,
    fromTaskEdit,
    taskForEditing,
    EditTask,
    type,
    fromSideDrawer = false,
    onClose,
    editChoice,
  } = props;

  const IOSSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const auth = useAuthUser();
  const authUser = auth();

  const { createTaskLoading, editTaskLoading } = useSelector(
    (state: any) => state.nurture
  );

  const combinedEmployees = getCombinedAssignees(employees, leadById?.branchId);
  const activeEmployees = combinedEmployees?.filter((item: any) => {
    return item.status === "ACTIVE" && item?.leadCardAccess === true;
  });

  const [taskDetails, setTaskDetails] = useState({
    description: fromTaskEdit ? taskForEditing?.description : "",
    mentionedIds: [],
    startDate: fromTaskEdit ? taskForEditing?.startDate : "",
    startTime: fromTaskEdit ? taskForEditing?.startTime : "",
    recurrence: fromTaskEdit ? taskForEditing?.recurrence : false,
    recurringInfo: fromTaskEdit ? taskForEditing?.recurringInfo || {} : {},
  });

  const [addTask, setAddTask] = useState("");
  const [taskTitle, setTaskTitle] = useState<string>(fromTaskEdit ? taskForEditing?.taskTitle || "" : "");
  const [assigny, setAssigny] = useState<any>("");
  const [priority, setPriority] = useState<any>("NORMAL");
  const [taskType, setTaskType] = useState<string>(fromTaskEdit ? "" : "");
  const [taskCategory, setTaskCategory] = useState<string>("General Task");

  const [errorTaskType, setErrorTaskType] = useState<boolean>(false);
  const [errorTaskCategory, setErrorTaskCategory] = useState<boolean>(false);
  const [errorAssigny, setErrorAssigny] = useState<boolean>(false);
  const [errorPriority, setErrorPriority] = useState<boolean>(false);
  const [errorDescription, setErrorDescription] = useState<boolean>(false);
  const [errorTaskTitle, setErrorTaskTitle] = useState<boolean>(false);
  const [isRecurrenceValid, setIsRecurrenceValid] = useState(true);
  const [errorStartDate, setErrorStartDate] = useState<boolean>(false);
  const [errorStartTime, setErrorStartTime] = useState<boolean>(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false);
  const [isTimePickerOpen, setIsTimePickerOpen] = useState<boolean>(false);
  const [closeRecurrencePickers, setCloseRecurrencePickers] = useState<boolean>(false);
  const [recurringInfo, setRecurringInfo] = useState(
    taskDetails.recurringInfo || {}
  );
  const [hasDuplicateDayNumbers, setHasDuplicateDayNumbers] = useState<boolean>(false);

  const [originalSeriesValues, setOriginalSeriesValues] = useState<{
    startDate: string;
    startTime: string;
    taskTitle: string;
    description: string;
    assigny: any;
    priority: string;
    taskType: string;
    recurringInfo: {
      startDate?: string | number;
      endDate?: string | number;
      frequency?: string;
      interval?: number;
      selectedWeekdays?: number[];
      monthlyDates?: string[];
      customDates?: string[] | { dates: number[] };
      weekly?: { daysOfWeek: number[] };
      monthly?: { dates: number[] };
    };
  } | null>(null);

  const originalValuesStoredRef = useRef<string | null>(null);
  const isInitializedRef = useRef<boolean>(false);
  const [hasAnyFieldChanged, setHasAnyFieldChanged] = useState<boolean>(false);

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => setPriority(leadPriority),
    []
  );

  const handleLeadAssignee = React.useCallback(
    (leadId: any, user: any) => setAssigny(user),
    []
  );

  const handleAddTask = (event: any) => {
    setAddTask(event.target.value);
    if (event.target.value) setErrorDescription(false);
  };
  const handleTaskTitle = (event: any) => {
    setTaskTitle(event.target.value);
    if (event.target.value) setErrorTaskTitle(false);
  };

  const handleCancel = () => {
    setAddTask("");
    setTaskTitle("");
    setOriginalSeriesValues(null);
    originalValuesStoredRef.current = null;
    handleCancelClick();
    onClose?.();
  };

  const handleSaveClick = async () => {

    const hasValidationErrors =
      !taskType ||
      !taskCategory ||
      !assigny ||
      !priority ||
      !addTask ||
      !taskTitle ||
      !taskDetails.startDate ||
      !taskDetails.startTime;

    setErrorTaskType(!taskType);
    setErrorTaskCategory(!taskCategory);
    setErrorAssigny(!assigny);
    setErrorPriority(!priority);
    setErrorDescription(!addTask);
    setErrorTaskTitle(!taskTitle);
    setErrorStartDate(!taskDetails.startDate);
    setErrorStartTime(!taskDetails.startTime);

    if (hasValidationErrors) {
      return;
    }

    const trimmedTime = taskDetails.startTime.trim();

    const isGeneralTask = taskCategory === "General Task" ||
      taskCategory === "GENERAL_TASK" ||
      (fromTaskEdit && taskForEditing?.taskCategory?.toUpperCase() === "GENERAL_TASK");

    let firstTimestamp: number;
    let hour: number;
    let minute: number;

    if (isGeneralTask) {
      const istMoment = moment.tz(
        `${taskDetails.startDate} ${trimmedTime}`,
        "YYYY-MM-DD HH:mm",
        "Asia/Kolkata"
      );
      firstTimestamp = istMoment.valueOf();

      hour = istMoment.hour();
      minute = istMoment.minute();
    } else {
      const utcMoment = moment.utc(
        `${taskDetails.startDate} ${trimmedTime}`,
        "YYYY-MM-DD HH:mm"
      );
      firstTimestamp = utcMoment.valueOf();
      hour = utcMoment.hour();
      minute = utcMoment.minute();
    }

    let recurringInfo: any = undefined;

    const isEditingEntireSeries = fromTaskEdit && editChoice === "series";
    const shouldBuildRecurringInfo = taskDetails.recurrence || (isEditingEntireSeries && taskForEditing?.recurringInfo);

    if (shouldBuildRecurringInfo) {
      const hasTaskDetailsRecurringInfo = taskDetails.recurringInfo &&
        taskDetails.recurringInfo.frequency &&
        Object.keys(taskDetails.recurringInfo).length > 0;

      const recurrence = hasTaskDetailsRecurringInfo
        ? taskDetails.recurringInfo
        : (fromTaskEdit && editChoice === "series" && taskForEditing?.recurringInfo
          ? taskForEditing.recurringInfo
          : {});

      const originalRecurringInfo = fromTaskEdit && taskForEditing?.recurringInfo
        ? taskForEditing.recurringInfo
        : null;


      let startDateIST = undefined;
      let endDateIST = undefined;

      if (recurrence.startDate) {
        if (typeof recurrence.startDate === 'number') {
          startDateIST = recurrence.startDate;
        } else {
          if (isGeneralTask) {
            startDateIST = moment.tz(recurrence.startDate, "YYYY-MM-DD", "Asia/Kolkata").startOf("day").valueOf();
          } else {
            startDateIST = moment.utc(recurrence.startDate, "YYYY-MM-DD").startOf("day").valueOf();
          }
        }
      }

      if (recurrence.endDate) {
        if (typeof recurrence.endDate === 'number') {
          endDateIST = recurrence.endDate;
        } else {
          if (isGeneralTask) {
            endDateIST = moment.tz(recurrence.endDate, "YYYY-MM-DD", "Asia/Kolkata").endOf("day").valueOf();
          } else {
            endDateIST = moment.utc(recurrence.endDate, "YYYY-MM-DD").endOf("day").valueOf();
          }
        }
      }

      let timeOfDayHour: number;
      let timeOfDayMinute: number;

      if (isEditingEntireSeries) {
        timeOfDayHour = hour;
        timeOfDayMinute = minute;

        if (isGeneralTask) {
          const istTimeMoment = moment.tz(
            `2000-01-01 ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
            "YYYY-MM-DD HH:mm",
            "Asia/Kolkata"
          );
          const utcTimeMoment = istTimeMoment.utc();
          timeOfDayHour = utcTimeMoment.hour();
          timeOfDayMinute = utcTimeMoment.minute();
        }
      } else {
        if (fromTaskEdit && originalRecurringInfo?.timeOfDay) {
          timeOfDayHour = originalRecurringInfo.timeOfDay.hour;
          timeOfDayMinute = originalRecurringInfo.timeOfDay.minute;
        } else if (recurrence?.timeOfDay) {
          timeOfDayHour = recurrence.timeOfDay.hour;
          timeOfDayMinute = recurrence.timeOfDay.minute;
        } else {
          timeOfDayHour = hour;
          timeOfDayMinute = minute;
          if (isGeneralTask) {
            const istTimeMoment = moment.tz(
              `2000-01-01 ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
              "YYYY-MM-DD HH:mm",
              "Asia/Kolkata"
            );
            const utcTimeMoment = istTimeMoment.utc();
            timeOfDayHour = utcTimeMoment.hour();
            timeOfDayMinute = utcTimeMoment.minute();
          }
        }
      }

      recurringInfo = {
        frequency: recurrence.frequency || originalRecurringInfo?.frequency || undefined,
        startDate: startDateIST,
        endDate: endDateIST,
        timeOfDay: { hour: timeOfDayHour, minute: timeOfDayMinute },
      };

      if (recurringInfo.frequency === "WEEKLY") {
        let daysOfWeek: number[] = [];

        if (recurrence.selectedWeekdays && recurrence.selectedWeekdays.length > 0) {
          daysOfWeek = recurrence.selectedWeekdays;
        } else if (recurrence.weekly?.daysOfWeek && recurrence.weekly.daysOfWeek.length > 0) {
          daysOfWeek = recurrence.weekly.daysOfWeek;
        } else if (originalRecurringInfo?.weekly?.daysOfWeek && originalRecurringInfo.weekly.daysOfWeek.length > 0) {
          daysOfWeek = originalRecurringInfo.weekly.daysOfWeek;
        }

        recurringInfo.weekly = {
          daysOfWeek: daysOfWeek,
        };
      }

      if (recurringInfo.frequency === "MONTHLY") {
        let dates: number[] = [];

        if (recurrence.monthlyDates && Array.isArray(recurrence.monthlyDates) && recurrence.monthlyDates.length > 0) {
          const validDates = recurrence.monthlyDates.filter((d: string | Date) => d && d !== "");
          if (validDates.length > 0) {
            dates = validDates.map((d: string | Date) => {
              const dateObj = new Date(d);
              return dateObj.getDate();
            });
          }
        }

        if (dates.length === 0 && recurrence.monthly?.dates && Array.isArray(recurrence.monthly.dates) && recurrence.monthly.dates.length > 0) {
          dates = recurrence.monthly.dates;
        }

        if (dates.length === 0 && originalRecurringInfo?.monthly?.dates && Array.isArray(originalRecurringInfo.monthly.dates) && originalRecurringInfo.monthly.dates.length > 0) {
          dates = originalRecurringInfo.monthly.dates;
        }

        if (dates.length > 0) {
          recurringInfo.monthly = {
            dates: dates,
          };
        }
      }

      if (recurringInfo.frequency === "CUSTOM") {
        let customDateTimestamps: number[] = [];

        if (recurrence.customDates && Array.isArray(recurrence.customDates) && recurrence.customDates.length > 0) {
          const validDates = recurrence.customDates.filter((d: string) => d && d !== "");
          if (validDates.length > 0) {
            customDateTimestamps = validDates.map((dateString: string) => {
              if (isGeneralTask) {
                const istMoment = moment.tz(
                  `${dateString} ${trimmedTime}`,
                  "YYYY-MM-DD HH:mm",
                  "Asia/Kolkata"
                );
                return istMoment.valueOf();
              } else {
                const utcMoment = moment.utc(
                  `${dateString} ${trimmedTime}`,
                  "YYYY-MM-DD HH:mm"
                );
                return utcMoment.valueOf();
              }
            });
          }
        }

        if (customDateTimestamps.length === 0 && recurrence.customDates?.dates && Array.isArray(recurrence.customDates.dates) && recurrence.customDates.dates.length > 0) {
          customDateTimestamps = recurrence.customDates.dates;
        }

        if (customDateTimestamps.length === 0 && originalRecurringInfo?.customDates?.dates && Array.isArray(originalRecurringInfo.customDates.dates) && originalRecurringInfo.customDates.dates.length > 0) {
          customDateTimestamps = originalRecurringInfo.customDates.dates;
        }

        if (customDateTimestamps.length > 0) {
          recurringInfo.customDates = {
            dates: customDateTimestamps,
          };
        }
      }
    }

    let payload: any = {};

    if (fromTaskEdit) {
      const isRecurring = !!(
        taskForEditing?.recurringTaskId ||
        taskForEditing?.recurrence ||
        taskForEditing?.recurringInfo ||
        taskForEditing?.isRecurring ||
        taskDetails.recurrence
      );

      const isEditingEntireSeries = editChoice === "series";

      let actionToPerform = "UPDATE_GENERAL_TASK";

      if (isEditingEntireSeries && isRecurring) {
        actionToPerform = "UPDATE_GENERAL_RECURRING_TASK";
      } else if (!isEditingEntireSeries && taskDetails.recurrence && recurringInfo) {
        actionToPerform = "UPDATE_GENERAL_RECURRING_TASK";
      }

      const instituteId =
        authUser?.institute[0]?.instituteId ||
        authUser?.institute[0]?.instituteDetails?.id;
      const instituteName =
        authUser?.institute[0]?.instituteDetails?.instituteName || "";

      payload = {
        taskCategory: "GENERAL_TASK",
        actionToPerform: actionToPerform,
        assignedToId: assigny.id,
        status: taskForEditing?.status || "TO_DO",
        entitytype: "task",
        date: firstTimestamp,
        taskCompletedDate: taskForEditing?.taskCompletedDate || 0,
        id: taskForEditing?.id,
        priority: priority.toUpperCase(),
        creationDate: taskForEditing?.creationDate || Date.now(),
        taskType: taskType.toUpperCase(),
        assignedToName: `${assigny.firstName} ${assigny.lastName}`,
        description: addTask,
        taskTitle: taskTitle,
        updatedById: authUser?.institute[0]?.id,
        updatedByName: `${authUser?.firstName} ${authUser?.lastName}`,
        mentionedIds: taskDetails.mentionedIds || [],
        instituteId: instituteId,
        instituteName: instituteName,
      };

      if (isRecurring) {
        if (isEditingEntireSeries) {
          payload.dateChanged = false;
        } else {
          const dateChanged = originalSeriesValues &&
            taskDetails.startDate !== originalSeriesValues.startDate;
          const timeChanged = originalSeriesValues &&
            taskDetails.startTime !== originalSeriesValues.startTime;

          payload.dateChanged = dateChanged || timeChanged;
        }
      }

      if (actionToPerform === "UPDATE_GENERAL_RECURRING_TASK") {
        if (!recurringInfo && isEditingEntireSeries && taskForEditing?.recurringInfo) {
          const originalRecurringInfo = taskForEditing.recurringInfo;

          let timeOfDayHour = hour;
          let timeOfDayMinute = minute;

          if (isGeneralTask) {
            const istTimeMoment = moment.tz(
              `2000-01-01 ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
              "YYYY-MM-DD HH:mm",
              "Asia/Kolkata"
            );
            const utcTimeMoment = istTimeMoment.utc();
            timeOfDayHour = utcTimeMoment.hour();
            timeOfDayMinute = utcTimeMoment.minute();
          }

          recurringInfo = {
            frequency: originalRecurringInfo.frequency,
            startDate: originalRecurringInfo.startDate,
            endDate: originalRecurringInfo.endDate,
            timeOfDay: { hour: timeOfDayHour, minute: timeOfDayMinute },
          };

          if (originalRecurringInfo.frequency === "WEEKLY" && originalRecurringInfo.weekly?.daysOfWeek) {
            recurringInfo.weekly = {
              daysOfWeek: originalRecurringInfo.weekly.daysOfWeek,
            };
          }

          if (originalRecurringInfo.frequency === "MONTHLY" && originalRecurringInfo.monthly?.dates) {
            recurringInfo.monthly = {
              dates: originalRecurringInfo.monthly.dates,
            };
          }

          if (originalRecurringInfo.frequency === "CUSTOM" && originalRecurringInfo.customDates?.dates) {
            recurringInfo.customDates = {
              dates: originalRecurringInfo.customDates.dates,
            };
          }
        }

        if (recurringInfo) {
          payload.recurringInfo = recurringInfo;
        }
      }
    } else {
      payload = {
        taskCategory: formatTaskCategory(taskCategory),
        isRecurring: !!taskDetails.recurrence,
        description: addTask,
        taskTitle: taskTitle,
        taskType: taskType.toUpperCase(),
        assignedToName: `${assigny.firstName} ${assigny.lastName}`,
        assignedToId: assigny.id,
        priority: priority.toUpperCase(),
        date: firstTimestamp,
        status: "TO_DO",
        createdById: authUser?.institute[0]?.id,
        createdByName: `${authUser?.firstName} ${authUser?.lastName}`,
        mentionedIds: taskDetails.mentionedIds || [],
        instituteId: authUser?.institute[0]?.instituteDetails?.id,
        instituteName: authUser?.institute[0]?.instituteDetails?.instituteName,
        recurringInfo: recurringInfo,
      };
    }

    try {
      if (fromTaskEdit) {
        await EditTask(payload);
      } else {
        await CreateTask(payload);
        onClose?.();
      }
    } catch (error) {
      console.error("Failed to save task:", error);
    }
  };

  function getNameById(id: any) {
    const employee = employees?.find((e: any) => e.id === id);
    return employee
      ? `${employee.firstName.charAt(0).toUpperCase() +
      employee.firstName.slice(1)
      } ${employee.lastName.charAt(0).toUpperCase() + employee.lastName.slice(1)
      }`
      : "Unknown";
  }

  const modifiedActiveEmployees = activeEmployees?.map((employee: any) => ({
    id: employee.id,
    display: `${employee.firstName} ${employee.lastName}`,
  }));

  useEffect(() => {
    if (fromTaskEdit && taskForEditing) {
      const user = employees?.find(
        (item: any) => item?.id === taskForEditing?.assignedToId
      );
      const task = taskTypes?.find(
        (item: any) => item?.id === taskForEditing?.taskTypeId
      );
      setAssigny(user);
      setPriority(taskForEditing?.priority);
      setTaskType(task?.taskTypeName || taskForEditing?.taskType);
      setAddTask(taskForEditing?.description || "");
      setTaskTitle(taskForEditing?.taskTitle || "");
      setTaskCategory(taskForEditing?.taskCategory || "");

      let startDate = taskForEditing?.startDate || "";
      let startTime = taskForEditing?.startTime || "";

      if (taskForEditing?.date &&
        (!startDate || startDate === "" || !startTime || startTime === "")) {
        const istMoment = moment(taskForEditing.date).tz("Asia/Kolkata");
        startDate = istMoment.format("YYYY-MM-DD");
        startTime = istMoment.format("HH:mm");
      }

      const hasRecurrence = !!(
        taskForEditing?.recurrence ||
        taskForEditing?.recurringInfo ||
        taskForEditing?.isRecurring ||
        taskForEditing?.recurringTaskId
      );

      const shouldEnableRecurrence = editChoice === "series" ? hasRecurrence : false;

      let convertedRecurringInfo: any = {};
      if (hasRecurrence && taskForEditing?.recurringInfo) {
        const backendRecurringInfo = taskForEditing.recurringInfo;

        let recurrenceStartDate = "";
        if (backendRecurringInfo.startDate) {
          recurrenceStartDate = moment(backendRecurringInfo.startDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
        }

        let recurrenceEndDate = "";
        if (backendRecurringInfo.endDate) {
          recurrenceEndDate = moment(backendRecurringInfo.endDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
        }

        convertedRecurringInfo = {
          frequency: backendRecurringInfo.frequency || "",
          startDate: recurrenceStartDate,
          endDate: recurrenceEndDate,
          interval: 1,
          selectedWeekdays: [],
          monthlyDates: [],
        };

        if (backendRecurringInfo.frequency === "WEEKLY" && backendRecurringInfo.weekly?.daysOfWeek) {
          convertedRecurringInfo.selectedWeekdays = backendRecurringInfo.weekly.daysOfWeek || [];
        }

        if (backendRecurringInfo.frequency === "MONTHLY" && backendRecurringInfo.monthly?.dates) {
          const dayNumbers = backendRecurringInfo.monthly.dates || [];
          convertedRecurringInfo.interval = dayNumbers.length || 1;

          if (recurrenceStartDate && recurrenceEndDate) {
            const startMoment = moment.tz(recurrenceStartDate, "YYYY-MM-DD", "Asia/Kolkata");
            const endMoment = moment.tz(recurrenceEndDate, "YYYY-MM-DD", "Asia/Kolkata");

            convertedRecurringInfo.monthlyDates = dayNumbers.map((dayNum: number) => {
              let currentMonth = startMoment.startOf('month');
              const endMonth = endMoment.startOf('month');

              while (currentMonth.isBefore(endMonth, 'month') || currentMonth.isSame(endMonth, 'month')) {
                const candidateDate = currentMonth.clone().date(dayNum);

                if (candidateDate.isValid() &&
                  candidateDate.date() === dayNum &&
                  (candidateDate.isAfter(startMoment, 'day') || candidateDate.isSame(startMoment, 'day')) &&
                  (candidateDate.isBefore(endMoment, 'day') || candidateDate.isSame(endMoment, 'day'))) {
                  return candidateDate.format("YYYY-MM-DD");
                }

                currentMonth = currentMonth.add(1, 'month');
              }

              return startMoment.format("YYYY-MM-DD");
            });
          } else {
            let baseDate = recurrenceStartDate;
            if (taskForEditing?.date) {
              const taskDateMoment = moment(taskForEditing.date).tz("Asia/Kolkata");
              baseDate = taskDateMoment.format("YYYY-MM-DD");
            }

            if (baseDate) {
              const baseMoment = moment.tz(baseDate, "YYYY-MM-DD", "Asia/Kolkata");
              convertedRecurringInfo.monthlyDates = dayNumbers.map((dayNum: number) => {
                const dateMoment = baseMoment.clone().date(dayNum);
                if (dateMoment.date() !== dayNum) {
                  return dateMoment.endOf('month').format("YYYY-MM-DD");
                }
                return dateMoment.format("YYYY-MM-DD");
              });
            }
          }
        }

        if (backendRecurringInfo.frequency === "CUSTOM" && backendRecurringInfo.customDates?.dates) {
          const timestamps = backendRecurringInfo.customDates.dates || [];
          convertedRecurringInfo.customDates = timestamps.map((timestamp: number) => {
            return moment(timestamp).tz("Asia/Kolkata").format("YYYY-MM-DD");
          });
        }
      }

      const taskId = taskForEditing?.id || taskForEditing?.activityId;
      if (originalValuesStoredRef.current !== taskId) {
        const originalRecurringInfo = taskForEditing?.recurringInfo || {};
        const storedRecurringInfo: any = {};

        if (hasRecurrence && Object.keys(originalRecurringInfo).length > 0) {
          storedRecurringInfo.startDate = originalRecurringInfo.startDate;
          storedRecurringInfo.endDate = originalRecurringInfo.endDate;
          storedRecurringInfo.frequency = originalRecurringInfo.frequency;

          if (originalRecurringInfo.frequency === "MONTHLY") {
            storedRecurringInfo.interval = convertedRecurringInfo.interval || 1;
            storedRecurringInfo.monthlyDates = convertedRecurringInfo.monthlyDates || [];
            if (originalRecurringInfo.monthly) {
              storedRecurringInfo.monthly = originalRecurringInfo.monthly;
            }
          }

          if (originalRecurringInfo.frequency === "WEEKLY") {
            storedRecurringInfo.selectedWeekdays = convertedRecurringInfo.selectedWeekdays || [];
            if (originalRecurringInfo.weekly) {
              storedRecurringInfo.weekly = originalRecurringInfo.weekly;
            }
          }

          if (originalRecurringInfo.frequency === "CUSTOM") {
            storedRecurringInfo.customDates = convertedRecurringInfo.customDates || [];
            if (originalRecurringInfo.customDates) {
              storedRecurringInfo.customDates = originalRecurringInfo.customDates;
            }
          }
        }

        setOriginalSeriesValues({
          startDate: startDate,
          startTime: startTime,
          taskTitle: taskForEditing?.taskTitle || "",
          description: taskForEditing?.description || "",
          assigny: user,
          priority: taskForEditing?.priority,
          taskType: task?.taskTypeName || taskForEditing?.taskType || "",
          recurringInfo: storedRecurringInfo,
        });
        originalValuesStoredRef.current = taskId;
        isInitializedRef.current = false;
        setHasAnyFieldChanged(false);
      }

      setTaskDetails((prev) => ({
        ...prev,
        mentionedIds: taskForEditing?.mentionedIds || [],
        startDate: startDate,
        startTime: startTime,
        recurrence: shouldEnableRecurrence,
        recurringInfo: editChoice === "series" ? convertedRecurringInfo : (hasRecurrence ? convertedRecurringInfo : {}),
      }));
    } else {
      const userFromLocalStorage = authUser;
      if (employees && userFromLocalStorage) {
        const user = employees.find(
          (item: any) =>
            item.email.toLowerCase() ===
            userFromLocalStorage.email.toLowerCase()
        );
        setAssigny(user);
      }
    }
  }, [employees, fromTaskEdit, taskForEditing, authUser, taskTypes, editChoice]);

  useEffect(() => {
    setRecurringInfo((prev: any) => ({
      ...prev,
      startDate: taskDetails.startDate || prev.startDate,
      timeOfDay: prev.timeOfDay || { hour: 0, minute: 0 },
    }));
  }, [taskDetails.startDate]);

  useEffect(() => {

    if (fromTaskEdit && editChoice === "series") return;

    if (taskDetails.startDate && taskDetails.recurrence) {
      setTaskDetails((prev: any) => ({
        ...prev,
        recurringInfo: {
          ...prev.recurringInfo,
          startDate: taskDetails.startDate,
        },
      }));
    }
  }, [taskDetails.startDate, taskDetails.recurrence, fromTaskEdit, editChoice]);

  useEffect(() => {
    if (!fromTaskEdit) {
      setOriginalSeriesValues(null);
      originalValuesStoredRef.current = null;
      isInitializedRef.current = false;
    }
  }, [fromTaskEdit]);


  useEffect(() => {
    if (fromTaskEdit && originalSeriesValues && !isInitializedRef.current) {
      const timer = setTimeout(() => {
        isInitializedRef.current = true;
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [fromTaskEdit, originalSeriesValues]);

  const normalizeDateForComparison = (date: string | number | undefined): string | undefined => {
    if (!date) return undefined;
    if (typeof date === 'number') {
      return moment(date).tz("Asia/Kolkata").format("YYYY-MM-DD");
    }
    return date;
  };

  const arraysEqual = (a: any[] | undefined, b: any[] | undefined): boolean => {
    if (!a && !b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return JSON.stringify(sortedA) === JSON.stringify(sortedB);
  };

  const hasRecurrenceFieldsChanged = React.useMemo(() => {
    if (!fromTaskEdit || editChoice !== "series" || !originalSeriesValues || !isInitializedRef.current) {
      return false;
    }

    const current = taskDetails;
    const original = originalSeriesValues;
    const currentRecurring = current.recurringInfo || {};
    const originalRecurring = original.recurringInfo || {};

    if (current.startDate !== original.startDate) {
      return true;
    }

    if (current.startTime !== original.startTime) {
      return true;
    }

    const currentRecurrenceStartDate = normalizeDateForComparison(currentRecurring.startDate);
    const originalRecurrenceStartDate = normalizeDateForComparison(originalRecurring.startDate);
    if (currentRecurrenceStartDate !== originalRecurrenceStartDate) {
      return true;
    }

    const currentEndDate = normalizeDateForComparison(currentRecurring.endDate);
    const originalEndDate = normalizeDateForComparison(originalRecurring.endDate);
    if (currentEndDate !== originalEndDate) {
      return true;
    }

    if (currentRecurring.interval !== originalRecurring.interval) {
      return true;
    }
    if (currentRecurring.frequency !== originalRecurring.frequency) {
      return true;
    }

    if (currentRecurring.frequency === "WEEKLY" || originalRecurring.frequency === "WEEKLY") {
      const currentDays = currentRecurring.selectedWeekdays || currentRecurring.weekly?.daysOfWeek || [];
      const originalDays = originalRecurring.selectedWeekdays || originalRecurring.weekly?.daysOfWeek || [];
      if (!arraysEqual(currentDays, originalDays)) {
        return true;
      }
    }

    if (currentRecurring.frequency === "MONTHLY" || originalRecurring.frequency === "MONTHLY") {
      const currentDates = currentRecurring.monthlyDates || [];
      const originalDates = originalRecurring.monthlyDates || [];

      const currentDayNumbers = currentDates
        .filter((d: string) => d && d !== "")
        .map((d: string) => new Date(d).getDate())
        .sort();
      const originalDayNumbers = originalDates
        .filter((d: string) => d && d !== "")
        .map((d: string) => new Date(d).getDate())
        .sort();

      const currentBackendDates = currentRecurring.monthly?.dates || [];
      const originalBackendDates = originalRecurring.monthly?.dates || [];

      if (!arraysEqual(currentDayNumbers, originalDayNumbers) ||
        !arraysEqual(currentBackendDates, originalBackendDates)) {
        return true;
      }
    }

    if (currentRecurring.frequency === "CUSTOM" || originalRecurring.frequency === "CUSTOM") {
      const currentCustomDates = Array.isArray(currentRecurring.customDates)
        ? currentRecurring.customDates
        : (currentRecurring.customDates?.dates || []);
      const originalCustomDates = Array.isArray(originalRecurring.customDates)
        ? originalRecurring.customDates
        : (originalRecurring.customDates?.dates || []);

      if (!arraysEqual(currentCustomDates, originalCustomDates)) {
        return true;
      }
    }

    return false;
  }, [fromTaskEdit, editChoice, originalSeriesValues, taskDetails]);

  const checkIfAnyFieldChanged = React.useCallback(() => {
    if (!fromTaskEdit || !originalSeriesValues || !isInitializedRef.current) {
      return true;
    }

    const current = {
      taskTitle,
      description: addTask,
      assigny: assigny?.id,
      priority,
      taskType,
      startDate: taskDetails.startDate,
      startTime: taskDetails.startTime,
      recurringInfo: taskDetails.recurringInfo,
    };

    const original = {
      taskTitle: originalSeriesValues.taskTitle,
      description: originalSeriesValues.description,
      assigny: originalSeriesValues.assigny?.id,
      priority: originalSeriesValues.priority,
      taskType: originalSeriesValues.taskType,
      startDate: originalSeriesValues.startDate,
      startTime: originalSeriesValues.startTime,
      recurringInfo: originalSeriesValues.recurringInfo,
    };

    if (current.taskTitle !== original.taskTitle) return true;
    if (current.description !== original.description) return true;
    if (current.assigny !== original.assigny) return true;
    if (String(current.priority).toUpperCase() !== String(original.priority).toUpperCase()) return true;
    if (String(current.taskType).toUpperCase() !== String(original.taskType).toUpperCase()) return true;
    if (current.startDate !== original.startDate) return true;
    if (current.startTime !== original.startTime) return true;

    const currentRecurring = current.recurringInfo || {};
    const originalRecurring = original.recurringInfo || {};

    const hasOriginalRecurring = originalRecurring && Object.keys(originalRecurring).length > 0;
    const hasCurrentRecurring = currentRecurring && Object.keys(currentRecurring).length > 0;

    if (hasOriginalRecurring !== hasCurrentRecurring) {
      return true;
    }

    if (hasOriginalRecurring || hasCurrentRecurring) {
      if (editChoice === "series") {
        if (currentRecurring.frequency !== originalRecurring.frequency) {
          return true;
        }

        const currentStartDate = normalizeDateForComparison(currentRecurring.startDate);
        const originalStartDate = normalizeDateForComparison(originalRecurring.startDate);
        if (currentStartDate !== originalStartDate) {
          return true;
        }

        const currentEndDate = normalizeDateForComparison(currentRecurring.endDate);
        const originalEndDate = normalizeDateForComparison(originalRecurring.endDate);
        if (currentEndDate !== originalEndDate) {
          return true;
        }

        if (currentRecurring.interval !== originalRecurring.interval) {
          return true;
        }

        if (currentRecurring.frequency === "WEEKLY" || originalRecurring.frequency === "WEEKLY") {
          const currentDays = currentRecurring.selectedWeekdays || currentRecurring.weekly?.daysOfWeek || [];
          const originalDays = originalRecurring.selectedWeekdays || originalRecurring.weekly?.daysOfWeek || [];
          if (!arraysEqual(currentDays, originalDays)) {
            return true;
          }
        }

        if (currentRecurring.frequency === "MONTHLY" || originalRecurring.frequency === "MONTHLY") {
          const currentMonthlyDates = currentRecurring.monthlyDates || [];
          const originalMonthlyDates = originalRecurring.monthlyDates || [];

          const currentDayNumbers = currentMonthlyDates
            .filter((d: string) => d && d !== "")
            .map((d: string) => new Date(d).getDate())
            .sort();
          const originalDayNumbers = originalMonthlyDates
            .filter((d: string) => d && d !== "")
            .map((d: string) => new Date(d).getDate())
            .sort();

          const currentBackendDates = currentRecurring.monthly?.dates || [];
          const originalBackendDates = originalRecurring.monthly?.dates || [];

          if (!arraysEqual(currentDayNumbers, originalDayNumbers) ||
            !arraysEqual(currentBackendDates, originalBackendDates)) {
            return true;
          }
        }

        if (currentRecurring.frequency === "CUSTOM" || originalRecurring.frequency === "CUSTOM") {
          const currentCustomDates = Array.isArray(currentRecurring.customDates)
            ? currentRecurring.customDates
            : (currentRecurring.customDates?.dates || []);
          const originalCustomDates = Array.isArray(originalRecurring.customDates)
            ? originalRecurring.customDates
            : (originalRecurring.customDates?.dates || []);

          if (!arraysEqual(currentCustomDates, originalCustomDates)) {
            return true;
          }
        }
      } else {
        if (currentRecurring.frequency !== originalRecurring.frequency) return true;

        const currentStartDate = currentRecurring.startDate;
        const originalStartDate = originalRecurring.startDate;
        if (currentStartDate !== originalStartDate) {
          const normalizedCurrent = typeof currentStartDate === 'number'
            ? moment(currentStartDate).tz("Asia/Kolkata").format("YYYY-MM-DD")
            : currentStartDate;
          const normalizedOriginal = typeof originalStartDate === 'number'
            ? moment(originalStartDate).tz("Asia/Kolkata").format("YYYY-MM-DD")
            : originalStartDate;
          if (normalizedCurrent !== normalizedOriginal) return true;
        }

        const currentEndDate = currentRecurring.endDate;
        const originalEndDate = originalRecurring.endDate;
        if (currentEndDate !== originalEndDate) {
          const normalizedCurrent = typeof currentEndDate === 'number'
            ? moment(currentEndDate).tz("Asia/Kolkata").format("YYYY-MM-DD")
            : currentEndDate;
          const normalizedOriginal = typeof originalEndDate === 'number'
            ? moment(originalEndDate).tz("Asia/Kolkata").format("YYYY-MM-DD")
            : originalEndDate;
          if (normalizedCurrent !== normalizedOriginal) return true;
        }

        if (currentRecurring.weekly || originalRecurring.weekly) {
          const currentDays = currentRecurring.weekly?.daysOfWeek || currentRecurring.selectedWeekdays || [];
          const originalDays = originalRecurring.weekly?.daysOfWeek || originalRecurring.selectedWeekdays || [];
          if (!arraysEqual(currentDays, originalDays)) return true;
        }

        if (currentRecurring.monthly || originalRecurring.monthly) {
          const currentDates = currentRecurring.monthly?.dates || [];
          const originalDates = originalRecurring.monthly?.dates || [];
          if (!arraysEqual(currentDates, originalDates)) return true;
        }

        if (currentRecurring.customDates || originalRecurring.customDates) {
          const currentCustomDates = Array.isArray(currentRecurring.customDates)
            ? currentRecurring.customDates
            : (currentRecurring.customDates?.dates || []);
          const originalCustomDates = Array.isArray(originalRecurring.customDates)
            ? originalRecurring.customDates
            : (originalRecurring.customDates?.dates || []);
          if (!arraysEqual(currentCustomDates, originalCustomDates)) return true;
        }
      }
    }

    return false;
  }, [fromTaskEdit, editChoice, originalSeriesValues, taskTitle, addTask, assigny, priority, taskType, taskDetails]);

  useEffect(() => {
    if (fromTaskEdit && isInitializedRef.current && originalSeriesValues) {
      const changed = checkIfAnyFieldChanged();
      setHasAnyFieldChanged(changed);
    }
  }, [fromTaskEdit, checkIfAnyFieldChanged, taskTitle, addTask, assigny, priority, taskType, taskDetails, originalSeriesValues]);

  const dateChanged = React.useMemo(() => {
    if (!fromTaskEdit || editChoice === "series" || !originalSeriesValues || !isInitializedRef.current) {
      return false;
    }

    const hasRecurringTaskId = !!taskForEditing?.recurringTaskId;
    const hasValidRecurringInfo = !!(
      taskForEditing?.recurringInfo &&
      taskForEditing?.recurringInfo?.frequency
    );
    const isRecurring = hasRecurringTaskId || hasValidRecurringInfo || taskForEditing?.isRecurring;

    if (!isRecurring) {
      return false;
    }

    const dateChangedValue = taskDetails.startDate !== originalSeriesValues.startDate;
    const timeChangedValue = taskDetails.startTime !== originalSeriesValues.startTime;

    return dateChangedValue || timeChangedValue;
  }, [fromTaskEdit, editChoice, originalSeriesValues, taskDetails.startDate, taskDetails.startTime, taskForEditing]);

  const isSaveDisabled =
    !addTask ||
    !taskTitle ||
    !assigny ||
    !priority ||
    !taskType ||
    !taskCategory ||
    !taskDetails.startDate ||
    !taskDetails.startTime ||
    createTaskLoading ||
    editTaskLoading ||
    (taskDetails.recurrence && !isRecurrenceValid) ||
    (taskDetails.recurrence && hasDuplicateDayNumbers);

  const [minTime, setMinTime] = useState("00:00");
  const [maxTime, setMaxTime] = useState("23:59");

  const descriptionContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (descriptionContainerRef.current) {
      const mentionsControl = descriptionContainerRef.current.querySelector('.mentions__control');
      const highlighter = descriptionContainerRef.current.querySelector('.mentions__highlighter');

      if (mentionsControl) {
        (mentionsControl as HTMLElement).style.position = 'relative';
        (mentionsControl as HTMLElement).style.overflow = 'hidden';
      }

      if (highlighter) {
        (highlighter as HTMLElement).style.overflow = 'hidden';
        (highlighter as HTMLElement).style.position = 'absolute';
        (highlighter as HTMLElement).style.top = '0';
        (highlighter as HTMLElement).style.left = '0';
        (highlighter as HTMLElement).style.right = '0';
        (highlighter as HTMLElement).style.bottom = '0';
        (highlighter as HTMLElement).style.pointerEvents = 'none';
      }
    }
  }, [addTask]);

  useEffect(() => {
    const tick = () => {
      if (!taskDetails.startDate) return;

      const nowIST = moment.tz("Asia/Kolkata");
      const selectedDateIST = moment.tz(taskDetails.startDate, "Asia/Kolkata");

      if (selectedDateIST.format("YYYY-MM-DD") === nowIST.format("YYYY-MM-DD")) {
        const newMinTime = nowIST.format("HH:mm");
        setMinTime(newMinTime);

        if (!fromTaskEdit) {
          if (!taskDetails.startTime || taskDetails.startTime < newMinTime) {
            setTaskDetails((prev) => ({ ...prev, startTime: newMinTime }));
          }
        }
      } else {
        setMinTime("00:00");
      }
    };

    tick();
    const interval = setInterval(tick, 60000);
    return () => clearInterval(interval);
  }, [taskDetails.startDate, taskDetails.startTime, fromTaskEdit]);

  return (
    <div style={{ backgroundColor: "#fff", marginBottom: "10px" }}>
      <div
        style={{
          margin: "10px 24px 16px 24px",
        }}
      >
        <Typography
          style={{
            fontWeight: 600,
            fontSize: "14px",
            marginBottom: "4px",
            display: "block",
            color: "#142C44",
          }}
        >
          Task Title
          <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          value={taskTitle}
          onChange={handleTaskTitle}
          placeholder="Enter task title"
          fullWidth
          size="small"
          required
          error={errorTaskTitle}
          helperText={errorTaskTitle ? "Task title is required" : ""}
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: errorTaskTitle ? "#d32f2f" : "#1976d2",
              },
            },
          }}
        />
      </div>
      <Typography
        style={{ fontWeight: 500, fontSize: "14px", margin: "5px 25px" }}
      >
        Description
        <span style={{ color: "red" }}>*</span>
      </Typography>
      <div
        ref={descriptionContainerRef}
        style={{
          borderRadius: "4px",
          border: errorDescription ? "1px solid #d32f2f" : "1px solid #E8E8E8",
          margin: "0px 24px 8px 24px",
          backgroundColor: "#fff",
        }}
      >
        <div style={{ padding: "10px", position: "relative", backgroundColor: "#fff", overflow: "hidden" }}>
          <MentionsInput
            value={addTask}
            onChange={handleAddTask}
            placeholder="Add Description"
            style={{
              control: {
                backgroundColor: "#fff",
                fontSize: "14px",
                color: "#69696B",
                minHeight: "140px",
                maxHeight: "300px",
                border: "none",
                padding: 0,
                position: "relative",
              },
              highlighter: {
                boxSizing: "border-box",
                backgroundColor: "transparent",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: "none",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              },
              input: {
                margin: 0,
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
                position: "relative",
                zIndex: 1,
                minHeight: "140px",
                maxHeight: "300px",
                overflowY: "auto",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              },
              suggestions: {
                width: "222px",
                zIndex: 2,
                overflow: "auto",
                maxHeight: "140px",
                backgroundColor: "#fff",
                border: "1px solid #F0F0F0",
                borderRadius: "6px",
                boxShadow: "0px 4px 15px rgba(0,0,0,0.06)",
                fontSize: "14px",
                position: "absolute",
                padding: "10px",
                color: "#142C44",
                fontWeight: "500",
              },
            }}
          >
            <Mention
              data={modifiedActiveEmployees}
              trigger="@"
              markup="@{{__id__}}"
              style={{
                display: "inline-block",
                backgroundColor: "#F5F5F7",
                padding: "2px 6px",
                borderRadius: "12px",
                lineHeight: "1.2",
                verticalAlign: "middle",
                marginRight: "2px",
                whiteSpace: "nowrap",
              }}
              displayTransform={(id: any) => "@" + getNameById(id)}
              onAdd={(id: any) =>
                setTaskDetails((prev: any) => ({
                  ...prev,
                  mentionedIds: prev.mentionedIds.includes(id)
                    ? prev.mentionedIds
                    : [...prev.mentionedIds, id],
                }))
              }
              renderSuggestion={(suggestion: any) => (
                <div
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    textTransform: "capitalize",
                  }}
                >
                  <Avatar
                    sx={{
                      width: "34px",
                      height: "34px",
                      fontSize: "16px",
                      alignItems: "center",
                      textTransform: "capitalize",
                      fontWeight: "500",
                      background: "#F5F5F7",
                      border: "1px solid #EEEEF4",
                      color: "#667085",
                    }}
                  >
                    <Box>{suggestion?.display?.charAt(0)}</Box>
                  </Avatar>
                  {suggestion?.display}
                </div>
              )}
            />
          </MentionsInput>
        </div>

        {errorDescription && (
          <Typography
            style={{
              color: "#d32f2f",
              fontSize: "12px",
              margin: "4px 10px 0px 10px",
            }}
          >
            Description is required
          </Typography>
        )}
        <div className={styles.activityArea}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderTop: "1px solid #F5F5F7",
              padding: "8px 8px",
            }}
          >
            <div className={styles.icons}>
              <TaskTypeSelect
                taskType={(type: string) => {
                  setTaskType(type);
                  if (type) setErrorTaskType(false);
                }}
                taskTypes={taskTypes || []}
                selectedTaskType={taskType || "General Task"}
              />
              <div className={styles.iconImage}>
                <FlagAssign
                  handleLeadPriority={(leadId: any, leadPriority: any) => {
                    setPriority(leadPriority);
                    if (leadPriority) setErrorPriority(false);
                  }}
                  selectedPriority={priority}
                />
              </div>
            </div>
          </Box>
        </div>
      </div>

      <Box sx={{ px: 3, mt: 1.25 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                marginBottom: "4px",
                display: "block",
              }}
            >
              Task Category
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField value={taskCategory} fullWidth size="small" disabled />
          </Grid>

          <Grid item xs={6}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                marginBottom: "4px",
                display: "block",
              }}
            >
              Assignee
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              select
              placeholder="Select Assignee"
              value={assigny?.id || ""}
              onChange={(e) => {
                const user = employees.find((u: any) => u.id === e.target.value);
                setAssigny(user);
                if (user) setErrorAssigny(false);
              }}
              fullWidth
              size="small"
              error={errorAssigny}
              helperText={errorAssigny ? "Assignee is required" : ""}
            >
              {employees?.map((emp: any) => (
                <MenuItem
                  key={emp.id}
                  value={emp.id}
                >{`${emp.firstName} ${emp.lastName}`}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                marginBottom: "4px",
                display: "block",
              }}
            >
              Task Date
              <span style={{ color: "red" }}>*</span>
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                onOpen={() => {
                  setIsDatePickerOpen(true);
                  setIsTimePickerOpen(false);
                  setCloseRecurrencePickers(true);
                  setTimeout(() => setCloseRecurrencePickers(false), 100);
                }}
                onClose={() => setIsDatePickerOpen(false)}
                open={isDatePickerOpen}
                value={taskDetails.startDate ? dayjs(taskDetails.startDate) : null}
                onChange={(date) => {
                  const dateString = date ? date.format("YYYY-MM-DD") : "";
                  setTaskDetails((prev) => ({
                    ...prev,
                    startDate: dateString,
                  }));
                  if (dateString) setErrorStartDate(false);
                }}
                format="DD-MM-YYYY"
                disablePast
                disabled={fromTaskEdit && editChoice === "series"}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    error: errorStartDate,
                    helperText: errorStartDate ? "Start date is required" : "",
                    onClick: (e: any) => {
                      if (fromTaskEdit && editChoice === "series") return;
                      e.stopPropagation();
                      setIsTimePickerOpen(false);
                      setCloseRecurrencePickers(true);
                      setTimeout(() => setCloseRecurrencePickers(false), 100);
                      setIsDatePickerOpen(true);
                    },
                    onBlur: (e: any) => {
                      const inputValue = e.target.value;
                      if (!inputValue) return;

                      let parsedDate = dayjs(inputValue, "DD-MM-YYYY", true);

                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(inputValue, "DD/MM/YYYY", true);
                      }
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(inputValue, "YYYY-MM-DD", true);
                      }
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(inputValue);
                      }

                      if (parsedDate.isValid()) {
                        const today = dayjs().startOf('day');
                        if (parsedDate.isBefore(today, 'day')) {
                          const currentDate = today.format("YYYY-MM-DD");
                          setTaskDetails((prev) => ({
                            ...prev,
                            startDate: currentDate,
                          }));
                          if (currentDate) setErrorStartDate(false);
                        } else {
                          const dateString = parsedDate.format("YYYY-MM-DD");
                          setTaskDetails((prev) => ({
                            ...prev,
                            startDate: dateString,
                          }));
                          if (dateString) setErrorStartDate(false);
                        }
                      }
                    },
                    sx: {
                      cursor: (fromTaskEdit && editChoice === "series") ? "not-allowed" : "text",
                      "& .MuiOutlinedInput-root": {
                        cursor: (fromTaskEdit && editChoice === "series") ? "not-allowed" : "text",
                        "& input": {
                          cursor: (fromTaskEdit && editChoice === "series") ? "not-allowed" : "text",
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                marginBottom: "4px",
                display: "block",
              }}
            >
              Task Time
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopTimePicker
                value={taskDetails.startTime ? dayjs(`2000-01-01 ${taskDetails.startTime.trim()}`, "YYYY-MM-DD HH:mm") : null}
                onOpen={() => {
                  setIsTimePickerOpen(true);
                  setIsDatePickerOpen(false);
                  setCloseRecurrencePickers(true);
                  setTimeout(() => setCloseRecurrencePickers(false), 100);
                }}
                onClose={() => setIsTimePickerOpen(false)}
                open={isTimePickerOpen}
                onChange={(time) => {
                  const timeString = time ? time.format("HH:mm") : "";
                  setTaskDetails((prev) => ({
                    ...prev,
                    startTime: timeString,
                  }));
                  if (timeString) setErrorStartTime(false);
                }}
                format="hh:mm A"
                minTime={dayjs(`2000-01-01 ${minTime}`, "YYYY-MM-DD HH:mm")}
                maxTime={dayjs(`2000-01-01 ${maxTime}`, "YYYY-MM-DD HH:mm")}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    placeholder: "Select Time",
                    error: errorStartTime,
                    helperText: errorStartTime ? "Start time is required" : "",
                    inputProps: {
                      readOnly: true,
                    },
                    onClick: (e: any) => {
                      e.stopPropagation();
                      setIsDatePickerOpen(false);
                      setCloseRecurrencePickers(true);
                      setTimeout(() => setCloseRecurrencePickers(false), 100);
                      setIsTimePickerOpen(true);
                    },
                    sx: {
                      cursor: "pointer",
                      "& .MuiOutlinedInput-root": {
                        cursor: "pointer",
                        "& input": {
                          cursor: "pointer",
                          caretColor: "transparent",
                        },
                        "& input::placeholder": {
                          opacity: 1,
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          margin: "10px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >

        {(!fromTaskEdit || editChoice === "series") && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Box
                sx={{
                  backgroundColor: "#F5F5F7",
                  borderRadius: "5px",
                  padding: "7px 15px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IOSSwitch
                  checked={fromTaskEdit && editChoice !== "series" ? false : (taskDetails.recurrence || false)}
                  disabled={fromTaskEdit}
                  onChange={(e) => {
                    const isChecked = e.target.checked;

                    if (!isChecked) {
                      setTaskDetails((prev: any) => ({
                        ...prev,
                        recurrence: false,
                        recurringInfo: {},
                      }));
                      setRecurringInfo({});
                      setHasDuplicateDayNumbers(false);
                      setIsRecurrenceValid(true);
                    } else {
                      setTaskDetails((prev: any) => ({
                        ...prev,
                        recurrence: true,
                      }));
                      setRecurringInfo((prev: any) => ({
                        ...prev,
                        startDate: taskDetails.startDate || "",
                        timeOfDay: prev.timeOfDay || { hour: 0, minute: 0 },
                      }));
                    }
                  }}
                />

                <Typography
                  style={{ fontWeight: 500, fontSize: "14px", margin: "0px 5px" }}
                >
                  Recurring
                </Typography>
              </Box>
            </div>
            {taskDetails.recurrence && (
              <Box
                sx={{
                  marginTop: "16px",
                  padding: "16px",
                  border: "1px solid #E8E8E8",
                  background: "#F5F5F7"
                }}
              >
                <Recurrence
                  value={taskDetails.recurringInfo}
                  onChange={(info: any) => {
                    setTaskDetails((prev: any) => ({
                      ...prev,
                      recurringInfo: info,
                    }));
                  }}
                  onValidityChange={setIsRecurrenceValid}
                  onDuplicateDayNumbersChange={setHasDuplicateDayNumbers}
                  taskStartDate={fromTaskEdit && editChoice === "series" ? undefined : taskDetails.startDate}
                  disableStartDate={!(fromTaskEdit && editChoice === "series")}
                  onRecurrenceDatePickerOpen={() => {
                    setIsDatePickerOpen(false);
                    setIsTimePickerOpen(false);
                  }}
                  closeRecurrencePickers={closeRecurrencePickers}
                />
              </Box>
            )}
          </>
        )}
        {dateChanged && (
          <Box
            sx={{
              marginTop: "16px",
              padding: "12px 16px",
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFD89C",
              borderRadius: "4px",
            }}
          >
            <Typography
              style={{
                fontSize: "14px",
                color: "#B45309",
                fontWeight: 500,
              }}
            >
              The task will be removed from the recurring series if date or time is changed.
            </Typography>
          </Box>
        )}
        {hasRecurrenceFieldsChanged && (
          <Box
            sx={{
              marginTop: "16px",
              padding: "12px 16px",
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFD89C",
              borderRadius: "4px",
            }}
          >
            <Typography
              style={{
                fontSize: "14px",
                color: "#B45309",
                fontWeight: 500,
              }}
            >
              {taskDetails.recurringInfo?.frequency === "WEEKLY"
                ? "Existing series will be removed and recreated with the updated weekdays."
                : taskDetails.recurringInfo?.frequency === "MONTHLY"
                  ? "Existing series will be removed and recreated with the updated month days."
                  : taskDetails.recurringInfo?.frequency === "CUSTOM"
                    ? "Existing series will be removed and recreated with the updated custom dates."
                    : "Existing series will be removed and recreated with the updated date."}
            </Typography>
          </Box>
        )}
        {taskDetails.recurrence && hasDuplicateDayNumbers && (
          <Box
            sx={{
              marginTop: "16px",
              padding: "12px 16px",
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFD89C",
              borderRadius: "4px",
            }}
          >
            <Typography
              style={{
                fontSize: "14px",
                color: "#B45309",
                fontWeight: 500,
              }}
            >
              Same numbers will not be allowed. Please ensure all selected dates have unique day numbers.
            </Typography>
          </Box>
        )}
      </div>

      <div style={{ margin: "8px 24px" }}>
        {(errorTaskType ||
          errorTaskCategory ||
          errorAssigny ||
          errorPriority ||
          errorDescription ||
          errorTaskTitle ||
          errorStartDate ||
          errorStartTime ||
          (taskDetails.recurrence && !isRecurrenceValid)) && (
            <div
              style={{ color: "red", padding: "5px 0 8px 0", fontSize: "14px" }}
            >
              Please fill all required details correctly
            </div>
          )}

        <div className={styles.cancelSave}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCancel}
            sx={{
              textTransform: "capitalize",
              color: "#9A9EA6",
              border: "1px solid #E3E3E3",
              px: 8,
              py: 1,
              minWidth: 100,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveClick}
            sx={{
              textTransform: "capitalize",
              px: 8,
              py: 1,
              minWidth: 100,
              backgroundColor: fromTaskEdit ? "#11c89b" : undefined,
              "&:hover": {
                backgroundColor: fromTaskEdit ? "#0fb889" : undefined,
              }
            }}
            disabled={isSaveDisabled}
          >
            {(!fromTaskEdit && createTaskLoading) ||
              (fromTaskEdit && editTaskLoading) ? (
              <CircularProgress size={20} color={"inherit"} />
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
